import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    socialAspectId: '',
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    socialAspectId: (state) => state.socialAspectId,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.socialAspectId = recordsData?.socialAspectId ? recordsData.socialAspectId : '';
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxASCxSocialPt4Schema(),
          apiClient.catBirthSexes(),
          apiClient.catGenders(),
          apiClient.catDuration(),
          apiClient.catCoupleBond(),
        ]);
        const [schemaRes, catBirthSexes, catGenders, catDuration, catCoupleBond] = responses.map(
          (res) => res?.data ?? {}
        );

        let id1 = 'G';
        const resCat5 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionG = resCat5.data.data;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[0].schemaForm.group1.schema.soc_couple_partner_sex_id.items =
          catBirthSexes.data ?? [];
        schema.schemaFormItems[0].schemaForm.group1.schema.soc_couple_partner_gen_id.items =
          catGenders.data ?? [];
        schema.schemaFormItems[0].schemaForm.group2.schema.soc_couple_in_dating_time.items =
          catDuration.data ?? [];
        schema.schemaFormItems[0].schemaForm.group2.schema.soc_couple_in_formal_time.items =
          catDuration.data ?? [];
        schema.schemaFormItems[0].schemaForm.group2.schema.couple_bond_id.items =
          catCoupleBond.data ?? [];
        schema.schemaFormItems[0].schemaForm.group2.schema.soc_relationship_level_description.items =
          catLevelDescriptionG;

        const modelFormItems = [{ modelForm: { group1: {}, group2: {}, group3: {} } }];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxASCxSocialPt4(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.social_aspect_id = dataModelFormItems[0].modelForm.social_aspect_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxASCxSocialPt4(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = model.socialAspectId;
        await apiClient.updateCAxASCxSocialPt4(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
